/**
 * ページユーティリティー
 * ページ関連
 *
 * No.    日付          更新者    更新内容
 *   1    2021/04/20            新規作成
 *
 * @summary ユーティリティーページ関連
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

//import {Util} from '../util.js';

export const Page = {};

Page.PageTop = {
    build: function() {
        const topBtn = document.createElement('p');
        topBtn.setAttribute('id', 'page-top');
        topBtn.innerHTML = '<a href="#"><span class="fas fa-arrow-alt-circle-up" aria-hidden="true"></span></a>';
        topBtn.classList.add('d-none');
        topBtn.style.opacity = 0;

        // Topに戻るボタン
        topBtn.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();

            var begin = new Date() - 0;
            var myTime = 300;
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var id = setInterval(function() {
                var current = new Date() - begin;
                if (current > myTime) {
                    clearInterval(id);
                    current = myTime;
                }
                window.scrollTo(0, scrollTop - scrollTop * (current / myTime));
            }, 10);

        }, false);

        //$('#footer').after(topBtn);
        document.body.appendChild(topBtn);
        //$('body').append(topBtn);
        //topBtn.hide();

        // スクロールが500に達したらボタン表示
        window.addEventListener('scroll', event => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //console.log('scrollTop',scrollTop);
            if (scrollTop > 100) {
                // fadeIn
                //console.log(topBtn.style.opacity === 0);
                if (topBtn.style.opacity === '0') {
                    topBtn.classList.remove('d-none');
                    var begin = new Date() - 0;
                    var myTime = 400;
                    var id = setInterval(function() {
                        var current = new Date() - begin;
                        if (current > myTime){
                            clearInterval(id);
                            current = myTime;
                        }
                        topBtn.style.opacity = current / myTime;
                        //console.log(topBtn.style.opacity);
                    }, 10);
                }
            } else {
                // fadeOut
                if (topBtn.style.opacity === '1') {
                    var begin2 = new Date() - 0;
                    var myTime2 = 400;
                    var id2 = setInterval(function() {
                        var current = new Date() - begin2;
                        if (current > myTime2) {
                            clearInterval(id2);
                            current = myTime2;
                            topBtn.style.opacity = 0;
                            topBtn.classList.add('d-none');
                        }
                        topBtn.style.opacity = 1 - (current / myTime2) ;
                    }, 10);
                }
            }
        }, false);
//        $(window).scroll(function() {
//          if ($(this).scrollTop() > 100) {
//            topBtn.fadeIn();
//          } else {
//            topBtn.fadeOut();
//          }
//        });
//
//        // スクロールでトップへもどる
//        topBtn.click(function() {
//          $('body,html').animate({
//            scrollTop: 0
//          }, 500);
//          return false;
//        });
    }
};
